module.exports = __webpack_public_path__ + "static/tw-mobile-trade-ab31f42158d65448108676009cb890db.jpg";